/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */


export const filterableKey = "FilterableProperty"

export function FilterableProperty(options = {}) {
	return function (target, propertyKey){
		if(typeof options === 'function'){
			options = {transform: options}
		}
		let defaultTransform = (val) => val
		let optionsFull = {
			...options,
			transform: options.transform || defaultTransform,
			isFilterable: true
		}
		Reflect.defineMetadata(filterableKey, optionsFull, target, propertyKey);

	}
}


export const syncKey = "SyncProperty"

export function SyncProperty(options = {}) {
	return function (target, propertyKey){
		let transform = item => item
		if(!options.targetProp){
			throw Error("SyncProperty: missing required option 'targetProp'.")
		}
		let optionsFull = {
			...options,
			transform: options.transform || transform,
			isSyncable: true
		}
		Reflect.defineMetadata(syncKey, optionsFull, target, propertyKey);

	}
}


